import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { MessageUtil } from 'src/app/utils/message.util';
import { PreAula } from 'src/app/models/pre-aula';
import { Location } from '@angular/common';
import { AulaService } from 'src/app/services/aula/aula.service';

@Component({
  selector: 'app-pre-aula',
  templateUrl: './pre-aula.component.html',
  styleUrls: ['./pre-aula.component.scss'],
})
export class PreAulaComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  aula = new PreAula();

  constructor(private activatedRoute: ActivatedRoute, private location: Location, private aulaService: AulaService) {}

  ngOnInit() {
    this.activatedRoute.params.subscribe((params) => {
      if (params['id'] > 0) {
        this.aula.id = params.id;
        this.getPreAula();
      } else {
        this.location.back();
      }
    });
  }

  getPreAula() {
    this.blockUI.start(MessageUtil.AGUARDE);
    this.aulaService.getPreAula(this.aula.id).subscribe(
      (aula: PreAula) => {
        this.blockUI.stop();
        this.aula = aula;
      },
      () => this.blockUI.stop()
    );
  }
}
